import { render, staticRenderFns } from "./IdeaCollectionListHeader.vue?vue&type=template&id=2042dac1&scoped=true"
import script from "./IdeaCollectionListHeader.vue?vue&type=script&lang=js"
export * from "./IdeaCollectionListHeader.vue?vue&type=script&lang=js"
import style0 from "./IdeaCollectionListHeader.vue?vue&type=style&index=0&id=2042dac1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2042dac1",
  null
  
)

export default component.exports